import { EOperationCodesC } from '@unikey/unikey-commons/release/comm';
import { api, environment } from '@alias-environment';

export const canI = (operation: EOperationCodesC, ...args: any): boolean => {
  return api.getPermissionMap().canI({
    wLogging: environment === 'development' && false
  })(operation, ...args);
};